export default __webpack_public_path__ + "static/media/offline.86ffa78d.svg";